export enum locationCreate {
	CREATE = '/locations'
}
